module.exports = __webpack_public_path__ + "img/ship.bd4431cd.svg";